export { Interpunct } from './interpunct'
